import { segs } from "./route";

/** Полоса сегментов = шаги трека: пройден · в работе · закрыт (A0). */
export function Segments({ total, done, active, height = 6 }: { total: number; done: number; active: boolean; height?: number }) {
  return (
    <div className="flex gap-[3px]" role="img" aria-label={`${done} из ${total}`}>
      {segs(total, done, active).map((s, i) => (
        <span
          key={i}
          className="flex-1 rounded-[2px]"
          style={{
            height,
            background: s === "done" ? "var(--acc)" : s === "active" ? "var(--accsoft)" : "var(--card2)",
            border: s === "active" ? "1px solid var(--accdim)" : undefined,
          }}
        />
      ))}
    </div>
  );
}
